import React from 'react';

import './styles.less';
import classNames from 'classnames';

/**
 * A component that wraps its children in a container with a max width
 * applied. By default, the max width is 1920px which can be used to
 * keep sections from expanding beyond a reasonable width on the page.
 * This component also has some simple padding applied to it.
 */
export const PageContainer = ( props ) => {

    return (
        <div className={ classNames( 'page-container', props.className ) } >
            { props.children }
        </div>
    );
};
